import Swiper from "swiper"

import { Autoplay, Navigation, Pagination, Thumbs, Scrollbar, Mousewheel } from "swiper/modules"

export default (params = { slidesPerView: 1 }, destroyOnResize = false) => ({
  swiper: null,
  initialized: false,
  productContainer: null,
  init() {
    this.initSlider()
    this.productContainer = document.getElementById("main-product")
    if (destroyOnResize) {
      this.destroyOnresize()
      window.addEventListener("resize", () => this.destroyOnresize())
    }
  },
  initSlider() {
    if (this.$el.classList.contains("swiper")) {
      this.swiper = new Swiper(this.$el, {
        modules: [Navigation, Pagination, Thumbs, Autoplay, Scrollbar, Mousewheel],
        ...params,
        on: {
          slideChange: (event) => {

            if (this.$el.classList.contains('modal-swiper')){
              let index_currentSlide = event.realIndex
              let currentSlide = event.slides[index_currentSlide]
              let videoContainer = currentSlide.querySelector(".video-container")
              const video = this.productContainer.querySelectorAll("video")

              if (!videoContainer && video.length) {
                video.forEach(vid => {
                  vid.pause()
                })
              }
              currentSlide.click()
            }
          },
          afterInit: ()=>{
            this.initialized = true
          }
        },
      })
    }
  },
  slideToIndex(index) {
    this.swiper.slideToLoop(index, 10)
  },
  destroyOnresize() {
    if (window.innerWidth > 990 && this.swiper) {
      this.swiper.destroy()
    } else {
      this.initSlider()
    }
  },
})
